export const callSettingsFr = {
  title: "Appels",
  weekday: "Heures permises en semaine",
  weekend: "Heures permises la fin de semaine",
  start: "Début",
  end: "Fin",
  business_days: "Jours ouvrables",
  days: {
    "1": "Lun",
    "2": "Mar",
    "3": "Mer",
    "4": "Jeu",
    "5": "Ven",
    "6": "Sam",
    "7": "Dim",
  },
  max_attempts: "Tentatives maximum",
  lease_minutes: "Durée du verrou (minutes)",
  predial_seconds: "Délai avant composition (secondes)",
  sip_server: "Serveur SIP",
  holidays: "Jours fériés (un par ligne, AAAA-MM-JJ)",
  script_fr: "Script (français)",
  script_en: "Script (anglais)",
  save: "Enregistrer",
  saved: "Paramètres d'appel enregistrés.",
  errors: {
    invalid_time: "Format HH:MM attendu.",
    end_before_start: "La fin doit suivre le début.",
    out_of_range: "Valeur hors limites.",
    invalid_date: "Date invalide (AAAA-MM-JJ).",
    outside_crtc:
      "Hors des heures permises par le CRTC (semaine 9 h – 21 h 30, fin de semaine 10 h – 18 h).",
    no_business_day: "Choisissez au moins un jour ouvrable.",
    invalid_sip_server: "Serveur SIP invalide.",
  },
};
